var React = require('react');

function Elevation (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.001 31H2a1 1 0 01-.857-1.514l9-15a.999.999 0 01.833-.485.96.96 0 01.856.445L21.535 29h6.501l-6-8.251-1.204 1.806a1 1 0 01-1.664-1.11l2-3c.182-.272.484-.438.812-.445.311 0 .637.147.829.412l8 11c.221.304.253.707.083 1.042A1.003 1.003 0 0130 31h-8.999zM3.766 29h15.365l-8.087-12.13L3.766 29z","key":0}),React.createElement("path",{"d":"M11 16a1 1 0 01-1-1V2a1 1 0 012 0v13a1 1 0 01-1 1z","key":1}),React.createElement("path",{"d":"M21 10H11a1 1 0 01-1-1V3a1 1 0 011-1h10a1 1 0 01.832 1.554L20.202 6l1.63 2.445A.998.998 0 0121 10zm-9-2h7.131l-.963-1.445a1 1 0 010-1.109L19.131 4H12v4z","key":2})]);
}

Elevation.defaultProps = {"height":"100","width":"100","viewBox":"0 0 32 32"};

module.exports = Elevation;

Elevation.default = Elevation;
